import { BaseInput } from '../base-input';
import { Component, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { MakeProvider } from "../../abstract-custom-control";

@Component({
    selector: 'yt-input',
    templateUrl: './input.component.html',
    providers: [ MakeProvider(InputComponent)],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputComponent extends BaseInput{
    constructor(protected changeDetectorRef: ChangeDetectorRef){
        super(changeDetectorRef);
    }
}